export const AdministrationRoleTypes = {
  OWNER: 'ROLE_OWNER',
  ACCOUNTANT: 'ROLE_ACCOUNTANT',
  READ_ONLY: 'ROLE_READ_ONLY',
}
